<template>
  <v-text-field-money
    v-model="humanizedValue"
    v-bind:properties="vuetifyTextFieldProps"
    v-bind:options="{
      locale: browserLanguage,
      length: Infinity,
      precision: 0, // No decimals support. Change to 2 if decimals are allowed and implement correct formatting in the handleChange method.
      empty: 0,
    }"
    :label="vuetifyTextFieldProps.label || ''"
    @input="handleChange"
  />
</template>

<script>
const DEFAULT_LANGUAGE = 'en-US'

export default {
  name: 'HumanizedNumericTextField',

  props: {
    vuetifyTextFieldProps: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [Number, String],
      default: 0,
    },
  },

  watch: {
    value(newValue) {
      this.humanizedValue = newValue.toString()
    },
  },

  data() {
    return {
      humanizedValue: this.value.toString(),
    }
  },

  computed: {
    browserLanguage() {
      return window.navigator.language || DEFAULT_LANGUAGE
    },
  },

  methods: {
    handleChange() {
      this.$emit(
        'change',
        Number((this.humanizedValue || '').replace(/,|\./g, ''))
      )
    },
  },
}
</script>
